import {
  ORDERS_DETAILS_URL_PARAMS,
  ORDERS_DETAILS_URL_PARAMS_PREFIX,
  ORDERS_URL_PARAMS,
} from '../constants';

import {browserHistory} from '@/shared/utils';

import {clearUrlParamsFromGrid} from './url-params';

interface SelectedOrder {
  poNumber: string;
  orderDate: string;
}

export const getSelectedOrder = (): SelectedOrder => ({
  poNumber: browserHistory.getParameterValue(
    ORDERS_DETAILS_URL_PARAMS.SELECTED_PO_NUMBER,
    ''
  ),
  orderDate: browserHistory.getParameterValue(
    ORDERS_DETAILS_URL_PARAMS.ORDER_DATE,
    ''
  ),
});

export const selectOrder = ({poNumber, orderDate}: SelectedOrder) =>
  browserHistory.setParametersValues([
    {name: ORDERS_DETAILS_URL_PARAMS.SELECTED_PO_NUMBER, value: poNumber},
    {name: ORDERS_DETAILS_URL_PARAMS.ORDER_DATE, value: orderDate},
  ]);

export const clearSelectedOrder = () =>
  clearUrlParamsFromGrid({
    urlPrefix: ORDERS_DETAILS_URL_PARAMS_PREFIX,
    additionalParams: [
      ORDERS_URL_PARAMS.SELECTED_PO_NUMBER,
      ORDERS_URL_PARAMS.ORDER_DATE,
      ORDERS_URL_PARAMS.SHIPPING_STATUS,
      ORDERS_URL_PARAMS.SEARCH,
      ORDERS_URL_PARAMS.PO_STATUS,
    ],
  });
